<template>
<div class="h-100 register-box" :class="[loading ? 'loading' : '']">

    <div class="stepper">
        <div v-text="__('trads.current-step', {
            current: currentStep + 1,
            total: steps.length
        })">
        </div>

        <div class="content d-flex">
            <div
                class="step rounded-pill"
                :class="{'on': index <= (currentStep+1)}"
                v-for="index in steps.length"
                :key="index"
                />
        </div>
    </div>

    <transition :name="slideDirection" mode="out-in" appear>
        <component
            v-for="(name, index) in visibleSteps"
            :is="name"
            :key="index"
            :selected="selected"
            :email="email"
            :coupon="coupon"
            :gift="gift"
        ></component>
    </transition>

    <!--transition :name="slideDirection" mode="out-in" appear>
        <component
            v-for="(name, index) in steps"
            v-bind:is="name"
            :key="index"
            v-if="currentStep == index && !loading"
            :selected="selected"
            :email="email"
            :coupon="coupon"
            :gift="gift"
        ></component>
    </transition-->

    <form ref="success" :action="success" method="post" id="succeeded">
        <input type="hidden" name="_token" v-model="csrf">
        <input type="hidden" name="checkout" v-model="checkout">
        <input type="hidden" name="transaction_id" v-model="transactionId">
        <input type="hidden" name="customer_id" v-model="customerId">
        <input type="hidden" name="price_id" v-model="priceId">
        <input type="hidden" name="email" v-model="email">
        <input type="hidden" name="password" v-model="password">
        <input type="hidden" name="newsletter" v-model="newsletter">
    </form>

    <form ref="redeem" :action="redeem" method="post" id="redeemed">
        <input type="hidden" name="_token" v-model="csrf">
        <input type="hidden" name="gift" v-model="gift">
        <input type="hidden" name="email" v-model="email">
        <input type="hidden" name="password" v-model="password">
        <input type="hidden" name="newsletter" v-model="newsletter">
    </form>

    <div v-if="debug">
        <button @click="previousStep">Previous</button>
        <span>Current : {{ steps[currentStep] }}</span>
        <button @click="nextStep">Next</button>

        <hr>
        <code>
            <div>Auth : {{ auth }}</div>
            <div>Email : {{ email }}</div>
            <div>Password : {{ password }}</div>
            <div>News : {{ newsletter }}</div>
            <div>Selected plan : {{ selected }}</div>
            <div>Success route : {{ success }}</div>
            <div>Coupon : {{ coupon }}</div>
            <div>Gift : {{ gift }}</div>
        </code>
    </div>
</div>

</template>

<script>
import StepAccount from './StepAccount.vue';
import StepPlan from './StepPlan.vue';
import StepPayment from './StepPayment.vue';
import { _topicWithOptions } from 'firebase-functions/v1/pubsub';

export default {
    components: {
        'step-account': StepAccount,
        'step-plan': StepPlan,
        'step-payment': StepPayment,
    },
    props: ['success', 'redeem', 'auth', 'debug', 'coupon', 'gift'],
    data () {
        return {
            loading: false,
            steps: [
                'step-account',
                'step-plan',
                'step-payment'
            ],
            slideDirection: 'slide-to-left',
            currentStep: 0,
            plans: {},
            defaultPlan: false,
            selected: false,
            checkout: false,
            transactionId: '',
            customerId: '',
            priceId: '',
            email: false,
            password: false,
            newsletter: false,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    beforeMount () {
        this.loading = true;

        // Gift is found, no payment
        if (this.gift) {
            this.steps = this.steps.slice(0, 1);
        }
        
        axios.post("/api/register/plans", {
            'locale': this.$lang().getLocale()
        }).then(response => {
            this.plans = response.data;
            if (!this.selected) {
                for(var n in this.plans) {
                    if (this.plans[n].selected == true) {
                        this.defaultPlan = this.plans[n].id;
                        break;
                    }
                }
            }
        }).catch(error => {
        }).then(response => {
            this.loading = false;
            if (this.auth) {
                this.email = this.auth.email;
                this.currentStep++;
            }
        });
    },
    mounted () {
        this.$root.$on('completedCheckout', (newCheckout) => {
            this.checkout = newCheckout;

            // Paddle Billing (v2): extract dedicated fields for SuccessController
            if (window.paddleBilling) {
                try {
                    const data = JSON.parse(newCheckout);
                    this.transactionId = data.transaction_id || '';
                    this.customerId    = (data.customer && data.customer.id) ? data.customer.id : '';
                    this.priceId       = (data.items && data.items[0] && data.items[0].price_id) ? data.items[0].price_id : '';
                } catch (e) {
                    console.error('Could not parse Paddle v2 checkout data', e);
                }
            }

            this.$nextTick(() => {
                if (this.gift) {
                    this.$refs.redeem.submit();
                    document.getElementById('redeemed').submit();
                } else {
                    this.$refs.success.submit();
                    document.getElementById('succeeded').submit();
                }
            });
        });
        this.$root.$on('selectedPlan', (newSelected) => {
            this.selected = newSelected
        });
        this.$root.$on('selectedEmail', (newEmail) => {
            this.email = newEmail.toLowerCase();
        });
        this.$root.$on('selectedPassword', (newPassword) => {
            this.password = newPassword
        });
        this.$root.$on('selectedNewsletter', (newNewsletter) => {
            this.newsletter = newNewsletter
        });
    },
    methods: {
        successStep: function() {
            const form = document.getElementById('succeeded');
            form.submit();
        },
        nextStep: function() {
            this.slideDirection = 'slide-to-left';
            if ((this.currentStep + 1) < this.steps.length) {
                this.currentStep++;
            }
        },
        previousStep: function() {
            this.slideDirection = 'slide-to-right';
            if ((this.currentStep - 1) >= 0) {
                this.currentStep--;
            }
        },
    },
    computed: {
    visibleSteps() {
        if (this.loading) {
            return [];
        }
        return this.steps.filter((step, index) => index === this.currentStep);
    }
}
}
</script>

<style>
.slide-to-left-enter-active, .slide-to-left-leave-active,
.slide-to-right-enter-active, .slide-to-right-leave-active {
    transition: all .2s;
}

.slide-to-left-enter, .slide-to-left-leave-to,
.slide-to-right-enter, .slide-to-right-leave-to {
    opacity: 0;
}
.slide-to-left-enter,
.slide-to-right-leave-to {
    transform: translateX(10%);
}
.slide-to-right-enter,
.slide-to-left-leave-to {
    transform: translateX(-10%);
}
</style>
